/* eslint-disable internal-rules/no-hardcoded-colors */
// These are dynamic color palette definitions that get applied as CSS custom properties
export const CUSTOM_STATUS_COLORS = Object.freeze({
    '#028CC2': {
        activeBackground: 'var(--palette-blue-30)',
        background: 'var(--palette-blue-10)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--palette-blue-70)',
    },
    '#5AB7CF': {
        activeBackground: 'var(--data-vis-teal-vis-teal-30)',
        background: 'var(--palette-blue-5)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--status-status-sorta-good)',
    },
    '#9440EE': {
        activeBackground: 'var(--palette-purple-30)',
        background: 'var(--palette-purple-10)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--palette-purple-80)',
    },
    '#FF7107': {
        activeBackground: 'var(--palette-orange-40)',
        background: 'var(--palette-orange-10)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--status-status-sorta-bad)',
    },
    '#009855': {
        activeBackground: 'var(--palette-green-40)',
        background: 'var(--palette-green-10)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--status-status-good)',
    },
    '#6A6C75': {
        activeBackground: 'var(--palette-gray-50)',
        background: 'var(--palette-gray-20)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--status-status-archive-done-off)',
    },
    '#DBA211': {
        activeBackground: 'var(--palette-yellow-40)',
        background: 'var(--palette-yellow-10)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--static-status-status-so-so)',
    },
    '#D035C1': {
        activeBackground: 'var(--palette-magenta-40)',
        background: 'var(--palette-magenta-10)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--status-status-ambiguous-3)',
    },
    '#CC0000': {
        activeBackground: 'var(--palette-red-40)',
        background: 'var(--palette-red-10)',
        textColor: 'var(--palette-gray-100)',
        dotColor: 'var(--status-status-bad)',
    },
});
